/**
 * menu theme
 * @see https://github.com/chakra-ui/chakra-ui/blob/%40chakra-ui/react%403.0.0/packages/react/src/theme/recipes/menu.ts
 */
import { defineSlotRecipe } from '@chakra-ui/react';
import { menuAnatomy } from '@chakra-ui/react/anatomy';
export const menu = defineSlotRecipe({
    slots: menuAnatomy.keys(),
    base: {},
    variants: {
        variant: {
            subtle: {
                trigger: {
                    textStyle: 'body3Bold',
                    _expanded: {
                        color: 'primary',
                    },
                },
                content: {
                    minW: '170px',
                    bgColor: 'background.offWhite',
                    rounded: '12px',
                    borderWidth: '2px',
                    borderColor: 'text.default',
                    textStyle: 'body3Bold',
                    px: '0',
                },
                item: {
                    cursor: 'pointer',
                    p: '12px 16px',
                },
                itemGroupLabel: {
                    textStyle: 'caption',
                    color: 'text.secondary',
                    px: '16px',
                    py: '0',
                },
            },
        },
    },
    compoundVariants: [],
    defaultVariants: {
        variant: 'subtle',
    },
});
